/* Bazaar Bee ad pixels (snippets/bb-pixels.liquid). Settings come from the COD app's "Pixels & API" tab
   (shop metafield bb_cod.config); while that is blank they come from <api>/config (5-minute sessionStorage cache).
   - Loads each enabled platform's official base code once and inits every enabled id:
     Meta (fbq), Google Ads + GA4 (gtag.js), Snapchat (snaptr), TikTok (ttq), Pinterest (pintrk), Microsoft UET (one queue per tag).
   - window.bbTrack(name, data) sends our events to every platform with its own event name:
     ViewContent, AddToCart, InitiateCheckout, AddPaymentInfo, Purchase, UpsellAccepted. Each one can be switched off in the
     settings (events.<key> === false). AddPaymentInfo (the COD form's Partial COD advance going to checkout): Meta
     AddPaymentInfo, GA4 add_payment_info, Snapchat ADD_BILLING, TikTok AddPaymentInfo; Pinterest and UET have no such event.
     data: { value, currency, contents: [{ id, quantity, item_price }], order_id?, event_id?, content_name?,
             form_version?, template? (COD form A/B version and template), user? (Purchase: Google Ads enhanced conversions) }
     Purchase (cod-<order id>) and UpsellAccepted (up-<order id>, or dn-<order id> for the downsell) carry the same event
     id as our server's Conversions API events, so each is counted once. GA4's upsell_accepted is skipped when the server sends it (settings.srv.ga4).
   - Automatic: PageView, ViewContent on product pages, AddToCart after a successful POST to /cart/add.
   - window.bbAttr(): ad click ids + cookies for the server events (URL click ids are kept 7 days in localStorage bb_attr).
   - Cookie banner (settings.consent.on): the pixels (and custom code) load only after "Accept";
     window.bbConsent() → 'yes' | 'no' | 'na' ('na' while the banner is off). */
(() => {
  if (window.BBPX) return;
  window.BBPX = true;
  const el = document.getElementById('bb-pixels-config');
  let cfg = {};
  try { cfg = JSON.parse(el ? el.textContent : '{}') || {}; } catch (e) { cfg = {}; }
  const CUR = cfg.currency || 'INR';
  const API = String(cfg.api || '').replace(/\/+$/, '');
  const ID = /^[A-Za-z0-9_\-:.]{2,64}$/;
  const LABEL = /^[A-Za-z0-9_\-]{1,64}$/;
  const G = 'bbcod'; // our gtag group: our events only go to our GA4 / Ads ids
  const EV = { ViewContent: 'viewcontent', AddToCart: 'addtocart', InitiateCheckout: 'initiatecheckout', AddPaymentInfo: 'addpaymentinfo', Purchase: 'purchase', UpsellAccepted: 'upsell' };
  const early = (window.bbTrack && Array.isArray(window.bbTrack.q) && window.bbTrack.q) || []; // calls made before this file ran
  const waiting = [];
  let S = null;          // { events, srv, ec (enhanced conversions), consent (banner on) }
  let all = null;        // enabled ids per platform, from the settings
  let on = {};           // the same once the pixels are loaded (after "Accept" while the cookie banner is on)
  let loaded = false, custom = null;
  let uetQueues = [];    // Microsoft UET queue names, one per tag
  const safe = (f) => { try { f(); } catch (e) { /* a pixel error must never break the store */ } };
  const num = (n) => Math.round((Number(n) || 0) * 100) / 100;
  // Google: the same item id as the Shopify Google & YouTube product feed (dynamic remarketing, Performance Max)
  const gid = (c) => (c.pid ? `shopify_IN_${c.pid}_${c.id}` : c.id);
  const str = (x) => (x == null ? undefined : String(x).trim());
  const clean = (o) => { Object.keys(o).forEach((k) => { if (o[k] === undefined || o[k] === '') delete o[k]; }); return o; };
  const list = (a) => {
    const seen = new Set();
    return (Array.isArray(a) ? a : []).filter((p) => p && p.on !== false && ID.test(String(p.id || '').trim())).map((p) => ({ ...p, id: String(p.id).trim() }))
      .filter((p) => !seen.has(p.id) && seen.add(p.id)).slice(0, 10);
  };

  /* ---------- ad click ids (URL, kept 7 days, the latest wins) + ad cookies, for the server events ---------- */
  const ATTR = 'bb_attr';
  const WEEK = 7 * 864e5;
  const readAttr = () => {
    let a = null;
    try { a = JSON.parse(localStorage.getItem(ATTR) || 'null'); } catch (e) { a = null; }
    const out = {};
    if (a && typeof a === 'object') Object.keys(a).forEach((k) => { const x = a[k]; if (x && typeof x.v === 'string' && x.v && Date.now() - Number(x.at) < WEEK) out[k] = { v: x.v, at: Number(x.at) }; });
    return out;
  };
  safe(() => {
    const q = new URLSearchParams(location.search);
    const a = readAttr(), before = JSON.stringify(a);
    [['fbclid', 'fbclid'], ['ttclid', 'ttclid'], ['ScCid', 'sccid'], ['gclid', 'gclid'], ['gbraid', 'gbraid'], ['wbraid', 'wbraid'], ['epik', 'epik']].forEach(([p, k]) => { const v = q.get(p); if (v && v.length <= 200) a[k] = { v, at: Date.now() }; });
    const now = JSON.stringify(a);
    if (now !== before || localStorage.getItem(ATTR) !== now) { if (Object.keys(a).length) localStorage.setItem(ATTR, now); else localStorage.removeItem(ATTR); }
  });
  const cookie = (n) => { try { const m = document.cookie.match(new RegExp(`(?:^|;\\s*)${n}=([^;]*)`)); return m ? decodeURIComponent(m[1]) : ''; } catch (e) { return ''; } };
  window.bbAttr = () => {
    const a = readAttr();
    const v = (k) => (a[k] ? a[k].v : '');
    const o = { fbp: cookie('_fbp'), fbc: cookie('_fbc') || (v('fbclid') ? `fb.1.${a.fbclid.at}.${v('fbclid')}` : ''), ttclid: v('ttclid'), ttp: cookie('_ttp'),
      sccid: v('sccid'), scid: cookie('_scid'), gclid: v('gclid'), gbraid: v('gbraid'), wbraid: v('wbraid'), epik: cookie('_epik') || v('epik'), ga: cookie('_ga') };
    Object.keys(o).forEach((k) => { if (!o[k] || o[k].length > 200) delete o[k]; });
    return o;
  };

  /* ---------- cookie banner (approved mockups/cod-phase2.html) ---------- */
  const CK = 'bb_consent';
  let choice = ''; // this page's answer when localStorage is blocked
  const stored = () => { try { const v = localStorage.getItem(CK); if (v === 'yes' || v === 'no') return v; } catch (e) { /* blocked */ } return choice; };
  window.bbConsent = () => (S ? (S.consent ? (stored() === 'yes' ? 'yes' : 'no') : 'na') : stored() || 'na');
  const BANNER_CSS = '.bbck{position:fixed;left:16px;right:16px;bottom:12px;z-index:1300;background:#fff;color:#111;border-radius:14px;box-shadow:0 8px 30px rgba(0,0,0,.28);padding:12px 13px;font-size:12.5px;line-height:1.45;text-align:start}'
    + '.bbck b{display:block;font-size:13.5px;margin-bottom:2px}.bbck-b{display:flex;gap:8px;margin-top:10px}'
    + '.bbck button{flex:1;margin:0;border-radius:10px;padding:10px;font-family:inherit;font-weight:800;font-size:13px;line-height:1.2;border:1.5px solid #d1d5db;background:#fff;color:#111;cursor:pointer}'
    + '.bbck button.y{background:#FFD400;border-color:#FFD400}@media (min-width:750px){.bbck{right:auto;width:420px;bottom:16px}}';
  function banner() {
    const put = () => {
      if (document.getElementById('bb-consent')) return;
      const st = document.createElement('style');
      st.textContent = BANNER_CSS;
      document.head.appendChild(st);
      const b = document.createElement('div');
      b.id = 'bb-consent'; b.className = 'bbck';
      b.setAttribute('role', 'region'); b.setAttribute('aria-label', 'Cookies');
      b.innerHTML = '<b>We use cookies</b>For ads and to see what works on our store. You can choose "Only needed".<div class="bbck-b"><button type="button" data-ck="no">Only needed</button><button type="button" class="y" data-ck="yes">Accept</button></div>';
      b.addEventListener('click', (e) => {
        const btn = e.target.closest && e.target.closest('[data-ck]');
        if (!btn) return;
        choice = btn.dataset.ck;
        try { localStorage.setItem(CK, choice); } catch (er) { /* this page only */ }
        b.remove();
        if (choice === 'yes') load(); else { early.length = 0; waiting.length = 0; } // "Only needed": nothing loads
      });
      document.body.appendChild(b);
    };
    if (document.body) put(); else document.addEventListener('DOMContentLoaded', put, { once: true });
  }

  /* ---------- official base codes ---------- */
  function loadMeta(ids, pv) {
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    ids.forEach((p) => window.fbq('init', p.id));
    if (pv) window.fbq('track', 'PageView');
  }
  function loadGtag(ga4, gads, pv) {
    const ids = [...ga4, ...gads];
    const s = document.createElement('script');
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(ids[0].id)}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag !== 'function') window.gtag = function gtag() { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    const base = pv ? { groups: G } : { groups: G, send_page_view: false };
    ga4.forEach((p) => window.gtag('config', p.id, { ...base }));
    gads.forEach((p) => window.gtag('config', p.id, S.ec ? { ...base, allow_enhanced_conversions: true } : { ...base }));
  }
  function loadSnap(ids, pv) {
    (function(e,t,n){if(e.snaptr)return;var a=e.snaptr=function()
    {a.handleRequest?a.handleRequest.apply(a,arguments):a.queue.push(arguments)};
    a.queue=[];var s='script';var r=t.createElement(s);r.async=!0;
    r.src=n;var u=t.getElementsByTagName(s)[0];
    u.parentNode.insertBefore(r,u);})(window,document,
    'https://sc-static.net/scevent.min.js');
    ids.forEach((p) => window.snaptr('init', p.id));
    if (pv) window.snaptr('track', 'PAGE_VIEW');
  }
  function loadTiktok(ids, pv) {
    !function (w, d, t) {
      w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(
      var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js",o=n&&n.partner;ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script")
      ;n.type="text/javascript",n.async=!0,n.src=r+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};
    }(window, document, 'ttq');
    ids.forEach((p) => window.ttq.load(p.id));
    if (pv) window.ttq.page();
  }
  function loadPinterest(ids, pv) {
    !function(e){if(!window.pintrk){window.pintrk = function () {
    window.pintrk.queue.push(Array.prototype.slice.call(arguments))};var
      n=window.pintrk;n.queue=[],n.version="3.0";var
      t=document.createElement("script");t.async=!0,t.src=e;var
      r=document.getElementsByTagName("script")[0];
      r.parentNode.insertBefore(t,r)}}("https://s.pinimg.com/ct/core.js");
    ids.forEach((p) => window.pintrk('load', p.id));
    if (pv) window.pintrk('page');
  }
  function loadUet(ids, pv) {
    // the UET snippet once per tag, each with its own queue (uetq, uetq2, uetq3 …); bat.js is fetched once
    const tags = ids.map((p, i) => ({ ti: p.id, q: i ? `uetq${i + 1}` : 'uetq' }));
    tags.forEach((x) => { window[x.q] = window[x.q] || []; });
    uetQueues = tags.map((x) => x.q);
    (function(w,d,t,r){var f,n,i;f=function(){tags.forEach(function(x){safe(function(){var o={ti:x.ti, enableAutoSpaTracking: true};o.q=w[x.q],w[x.q]=new UET(o);if(pv)w[x.q].push("pageLoad")})})},n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function(){var s=this.readyState;s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)},i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)})(window,document,"script","https://bat.bing.com/bat.js");
  }
  function loadCustom(c) { // only when the settings came late from the server or wait for the cookie banner; otherwise Liquid printed it
    if (!c || c.on !== true || !c.code) return;
    safe(() => { const frag = document.createRange().createContextualFragment(String(c.code)); (document.body || document.head).appendChild(frag); });
  }

  /* ---------- events ---------- */
  function send(name, data) {
    const key = EV[name];
    if (!key || (S.events && S.events[key] === false)) return;
    const d = data || {};
    const cur = String(d.currency || CUR);
    const value = num(d.value);
    const items = (Array.isArray(d.contents) ? d.contents : []).filter((c) => c && c.id != null && c.id !== '')
      .map((c) => ({ id: String(c.id), pid: c.pid ? String(c.pid) : undefined, quantity: Math.max(1, parseInt(c.quantity, 10) || 1), price: num(c.item_price), name: c.name ? String(c.name) : undefined }));
    const n = items.reduce((t, c) => t + c.quantity, 0);
    const eid = d.event_id ? String(d.event_id) : undefined;
    const oid = d.order_id ? String(d.order_id) : undefined;
    const buy = name === 'Purchase';
    const up = name === 'UpsellAccepted';
    const fv = str(d.form_version), tp = str(d.template); // COD form A/B version + template

    if (on.meta.length && window.fbq) safe(() => {
      const md = clean({ value, currency: cur, content_ids: items.map((c) => c.id), content_type: 'product', contents: items.map((c) => ({ id: c.id, quantity: c.quantity, item_price: c.price })), num_items: n, content_name: d.content_name, order_id: buy ? oid : undefined, form_version: fv, template: tp });
      const opt = eid ? { eventID: eid } : undefined;
      if (up) window.fbq('trackCustom', 'UpsellAccepted', md, opt);
      else window.fbq('track', name, md, opt);
    });
    // GA4 doesn't dedupe upsell_accepted: skip it when our server already sends it
    if ((on.ga4.length || on.gads.length) && window.gtag && !(up && S.srv.ga4 === true)) safe(() => {
      const gname = { ViewContent: 'view_item', AddToCart: 'add_to_cart', InitiateCheckout: 'begin_checkout', AddPaymentInfo: 'add_payment_info', Purchase: 'purchase', UpsellAccepted: 'upsell_accepted' }[name];
      if (buy && S.ec && on.gads.length && d.user && typeof d.user === 'object') window.gtag('set', 'user_data', userData(d.user)); // enhanced conversions
      window.gtag('event', gname, clean({ send_to: G, value, currency: cur, transaction_id: buy ? oid : undefined, items: items.map((c) => clean({ item_id: gid(c), item_name: c.name, price: c.price, quantity: c.quantity, google_business_vertical: 'retail' })), form_version: fv, template: tp }));
      if (buy) on.gads.filter((a) => LABEL.test(String(a.label || '').trim())).forEach((a) => window.gtag('event', 'conversion', clean({ send_to: `${a.id}/${String(a.label).trim()}`, value, currency: cur, transaction_id: oid })));
    });
    if (on.snap.length && window.snaptr) safe(() => {
      const sname = { ViewContent: 'VIEW_CONTENT', AddToCart: 'ADD_CART', InitiateCheckout: 'START_CHECKOUT', AddPaymentInfo: 'ADD_BILLING', Purchase: 'PURCHASE', UpsellAccepted: 'CUSTOM_EVENT_1' }[name];
      window.snaptr('track', sname, clean({ price: value, currency: cur, item_ids: items.map((c) => c.id), number_items: n, transaction_id: buy ? oid : undefined, client_dedup_id: buy || up ? eid : undefined }));
    });
    if (on.tiktok.length && window.ttq) safe(() => {
      const tname = { ViewContent: 'ViewContent', AddToCart: 'AddToCart', InitiateCheckout: 'InitiateCheckout', AddPaymentInfo: 'AddPaymentInfo', Purchase: 'CompletePayment', UpsellAccepted: 'AddToCart' }[name];
      const td = { contents: items.map((c) => clean({ content_id: c.id, content_type: 'product', content_name: c.name, quantity: c.quantity, price: c.price })), content_type: 'product', value, currency: cur };
      if (eid) window.ttq.track(tname, td, { event_id: eid }); else window.ttq.track(tname, td);
    });
    if (on.pinterest.length && window.pintrk) safe(() => {
      const pname = { ViewContent: 'pagevisit', AddToCart: 'addtocart', Purchase: 'checkout' }[name];
      if (!pname) return;
      window.pintrk('track', pname, clean({ value, currency: cur, order_quantity: n, order_id: buy ? oid : undefined, event_id: buy ? eid : undefined, line_items: items.map((c) => clean({ product_id: c.id, product_name: c.name, product_price: c.price, product_quantity: c.quantity })) }));
    });
    if (buy) uetQueues.forEach((q) => safe(() => { window[q].push('event', 'purchase', { revenue_value: value, currency: cur }); }));
  }
  // Google Ads enhanced conversions: gtag hashes these itself before sending
  const userData = (u) => {
    const ph = String(u.phone || '');
    return clean({ phone_number: /^\+91[6-9]\d{9}$/.test(ph) ? ph : undefined, address: clean({ first_name: str(u.first_name), last_name: str(u.last_name), city: str(u.city), region: str(u.region), postal_code: str(u.postal_code), country: 'IN' }) });
  };

  window.bbTrack = (name, data) => {
    if (loaded) { send(name, data); return; }
    if (S && S.consent && stored() === 'no') return; // "Only needed"
    if (waiting.length < 50) waiting.push([name, data]); // settings (or the cookie answer) still on their way
  };

  function start(s, late) {
    if (S || !s || typeof s !== 'object') return;
    const px = s.pixels || {};
    S = { events: s.events || {}, srv: s.srv && typeof s.srv === 'object' ? s.srv : {}, ec: s.gadsEnhanced === true, consent: !!(s.consent && s.consent.on === true) };
    all = { meta: list(px.meta), gads: list(px.gads), ga4: list(px.ga4), snap: list(px.snap), tiktok: list(px.tiktok), pinterest: list(px.pinterest), bing: list(px.bing) };
    custom = late || S.consent ? px.custom : null; // otherwise Liquid printed it already
    const c = stored();
    if (!S.consent || c === 'yes') load();
    else if (!c) banner();
    else { early.length = 0; waiting.length = 0; } // "Only needed": nothing loads
  }
  function load() {
    if (loaded || !S) return;
    loaded = true;
    on = all;
    const pv = S.events.pageview !== false;
    if (on.meta.length) safe(() => loadMeta(on.meta, pv));
    if (on.ga4.length || on.gads.length) safe(() => loadGtag(on.ga4, on.gads, pv));
    if (on.snap.length) safe(() => loadSnap(on.snap, pv));
    if (on.tiktok.length) safe(() => loadTiktok(on.tiktok, pv));
    if (on.pinterest.length) safe(() => loadPinterest(on.pinterest, pv));
    if (on.bing.length) safe(() => loadUet(on.bing, pv));
    if (custom) loadCustom(custom);
    const p = cfg.product;
    if (p && p.variant) {
      const price = num(Number(p.price) / 100);
      send('ViewContent', { value: price, currency: CUR, content_name: p.title, contents: [{ id: p.variant, pid: p.id, quantity: 1, item_price: price, name: p.title }] });
    }
    early.splice(0).concat(waiting.splice(0)).forEach((a) => safe(() => send(a[0], a[1])));
  }

  /* public config from our server while the shop metafield is blank (shared with bb-cod.js, 5-minute cache) */
  function remoteConfig() {
    if (window.bbCodConfigP) return window.bbCodConfigP;
    const KEY = 'bb_cod_cfg';
    window.bbCodConfigP = (async () => {
      try { const c = JSON.parse(sessionStorage.getItem(KEY) || 'null'); if (c && c.v && Date.now() - c.at < 300000) return c.v; } catch (e) { /* no cache */ }
      try {
        const r = await fetch(`${API}/config`, { headers: { Accept: 'application/json' } });
        if (!r.ok) return null;
        const d = await r.json();
        const v = d && typeof d === 'object' ? (d.config && typeof d.config === 'object' ? d.config : d.settings && typeof d.settings === 'object' ? d.settings : d) : null;
        if (!v || !(v.form || v.pixels || v.mode)) return null;
        try { sessionStorage.setItem(KEY, JSON.stringify({ at: Date.now(), v })); } catch (e) { /* private mode */ }
        return v;
      } catch (e) { return null; }
    })();
    return window.bbCodConfigP;
  }

  /* ---------- AddToCart: wrap fetch, fire after a successful POST to /cart/add(.js/.json) ---------- */
  const isAdd = (u) => { try { return /\/cart\/add(?:\.js|\.json)?\/?$/.test(new URL(u, location.href).pathname); } catch (e) { return false; } };
  const fromParams = (f) => {
    const id = f.get('id');
    if (id) return [{ id: String(id), quantity: parseInt(f.get('quantity'), 10) || 1 }];
    const out = [];
    for (let i = 0; i < 50; i++) { const v = f.get(`items[${i}][id]`); if (!v) break; out.push({ id: String(v), quantity: parseInt(f.get(`items[${i}][quantity]`), 10) || 1 }); }
    return out;
  };
  const fromBody = (b) => {
    try {
      if (!b) return [];
      if (typeof b === 'string') {
        try { const j = JSON.parse(b); return (Array.isArray(j.items) ? j.items : [j]).filter((x) => x && x.id).map((x) => ({ id: String(x.id), quantity: parseInt(x.quantity, 10) || 1 })); }
        catch (e) { return fromParams(new URLSearchParams(b)); }
      }
      if ((window.FormData && b instanceof FormData) || b instanceof URLSearchParams) return fromParams(b);
    } catch (e) { /* unknown body */ }
    return [];
  };
  function added(body, res) {
    const asked = fromBody(body);
    res.json().catch(() => null).then((d) => {
      const got = d && Array.isArray(d.items) ? d.items : d && (d.variant_id || d.id) ? [d] : [];
      const want = asked.length ? asked : got.map((x) => ({ id: String(x.variant_id || x.id), quantity: parseInt(x.quantity, 10) || 1 }));
      if (!want.length) return;
      const contents = want.map((w) => {
        const m = got.find((x) => String(x.variant_id || x.id) === w.id);
        const cents = m ? (m.final_price != null ? m.final_price : m.price) : 0;
        return { id: w.id, pid: m && m.product_id ? m.product_id : undefined, quantity: w.quantity, item_price: num(Number(cents) / 100), name: m ? m.product_title || m.title : undefined };
      });
      window.bbTrack('AddToCart', { value: contents.reduce((t, c) => t + c.item_price * c.quantity, 0), currency: CUR, contents });
    }).catch(() => {});
  }
  const realFetch = window.fetch;
  if (typeof realFetch === 'function' && !realFetch.bbWrapped) {
    const wrapped = function (input, init) {
      const p = realFetch.apply(window, arguments);
      safe(() => {
        const url = typeof input === 'string' ? input : input && (input.href || input.url);
        const method = String((init && init.method) || (input && typeof input === 'object' && input.method) || 'GET').toUpperCase();
        if (method === 'POST' && url && isAdd(url)) p.then((r) => { if (r && r.ok) added(init && init.body, r.clone()); }).catch(() => {});
      });
      return p;
    };
    wrapped.bbWrapped = true;
    window.fetch = wrapped;
  }

  if (cfg.settings && typeof cfg.settings === 'object') start(cfg.settings, false);
  else if (API) remoteConfig().then((s) => start(s, true)).catch(() => {});
})();
